import { get } from 'lodash';

export const getProducts = (state) => {
  return get(state, 'products', {});
};



// WEBPACK FOOTER //
// ./src/selectors/product_selector.js